// Module
var code = "<span class=\"currency\"> {{ formattedAmount }} </span> ";
// Exports
export default code;